<template>
  <div>
    <div class="pyShowPage"  ref="contactPage">
         <div class="title">
             <div class="titleText">{{$t('language.pingyaoShow')}}</div>
             <div class="titleline"></div>
         </div>
         <div class="listCon">
              <div class="listItem" v-for="(item,index) in listInfo" :key="index" @click="details(item.detail,item.cn_name)">
                   <div class="listItemCon">
                       <img class="listItemImg" :src="item.pic" alt="">
                       <div class="listItemText">
                           <div>{{item.cn_name}}</div>
                           <div>{{item.en_name}}</div>
                       </div>
                   </div>
              </div>
         </div>

        <div class="block"   v-show="total > 9">
            <span class="demonstration">{{$t('language.goUpto')}}</span>
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="9"
            layout="prev, pager, next, jumper"
            :total="total"
            background>
            </el-pagination>
        </div>
         <div style="height:60px;"></div>
    </div>
    <div class="footerCon">
		<div style="padding-top: 5px;padding-bottom: 5px;margin-right: 24px;"><a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 36px;'><img src='../../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a></div>
        <div class="address"><img src="../../assets/image/address.png" alt=""><div>{{$t('language.address_b')}}：山西省/晋中市/平遥县/顺城路/故宫文创</div></div>
        <div class="email"><img src="../../assets/image/email.png" alt=""><div>{{$t('language.emails')}}：{{info.email}}</div></div>
    </div>
    <Fixed :goTop="gotoT"></Fixed>
  </div>
</template>
<script>
import Fixed from '../../components/fixed.vue';
export default {
    name:'pingyaoShow',
    data(){
        return {
            listInfo:[{title:'柴油机厂',subTitle:'Diesel engine factory'},{title:'棉织厂',subTitle:'Cotton textile mill'},{title:'县衙',subTitle:'Country goverment'},
                      {title:'二郎庙',subTitle:'Erlang Temple'},{title:'城隍庙',subTitle:'Chenghuang temple'},{title:'清虚观',subTitle:'QingXuGuan'},
                      {title:'文庙',subTitle:'Confucian temple'},{title:'吉祥寺',subTitle:'Kichijoji'},{title:'小察院',subTitle:'Small Chayuan'}
                      ],
            currentPage: 1,
            total:1,
            info:{}
        }
    },
    components:{
       Fixed
    },
    mounted(){
        // 侧边菜单显示
        let fixCon = document.getElementsByClassName("fixed")[0]; 
        fixCon.style.opacity = "1";
        this.getInfo();
        this.$fetch('/index/info').then(res => {
            this.info = res.data;
        })
    },
    methods:{
       details(detail,cn_name){
          this.$router.push({
					path: '/newPage/richText',
					query: {
						detail:detail,
                        cn_name:cn_name
					}
				})  
       },
       // 顶部
       gotoT(){
          this.$refs.contactPage.scrollTop = 0;
       },
        // 获取初始化数据
       getInfo(){
        var data = {
          page: this.currentPage,
          count: 9
        }
        this.$fetch('Content/getExhibitionHall',data).then(res => {
            if(res.code == 200){
                let datas = res.data.info;
                this.currentPage = datas.current_page;
                this.total = datas.total;
                this.listInfo = datas.data;
                this.pages = this.listInfo.length;
            }
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange() {
        this.getInfo();
      }
    }
}
</script>
<style scoped>
.pyShowPage{
    padding: 39px 192px;
    font-family: Microsoft YaHei;
    height: 80vh;
    overflow: auto;
}
.title{
    font-size: 42px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.titleline{
    width: 53px;
    border: 3px solid #060001;
    margin-top: 14px;
}
.listCon{
    padding:0px 64px  30px 64px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.listItem{
    width: 240px;
    height: 325px;
    background: #AF011A;
    margin-right: 52px;
    margin-top: 40px;
}
/* .listItem:nth-of-type(5n+5){
    margin-right: 0px;
} */
.listItemCon{
    padding:24px 25px 26px 25px;
    display: flex;
    flex-direction: column;
} 
.listItemImg{
    width: 100%;
    height: 160px;
    background: #FFFFFF;
}
.listItemText{
    color:#FFFFFF;
}
.listItemText>div:nth-of-type(1){
    font-size: 21px;
    font-weight: bold;
    margin: 21px 0px 18px 0px;
}
.listItemText>div:nth-of-type(2){
    font-size: 14px;
    font-weight: bold;
}
.footerCon{
    width: 100%;
    height: 42px;
   background: rgba(245, 245, 245, 1);
    position: absolute;
    bottom: 0%;
    font-size: 14px;
    font-weight: bold;
    color: #3D3D3B;
    display: flex;
    justify-content: center;
}
.footerCon>div{
    display: flex;
    align-items: center;
}
.address{
    margin-right: 100px;
}
.address img{
    width: 20px;
    height: 22px;
    margin-right: 10px;
}
.email img{
    width: 19px;
    height: 14px;
    margin-right: 10px;
}
.block{
   display: flex;
   align-items: center;
   justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/newPage/pingyaoShow.vue